import styled from '@emotion/styled'

export const Item = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  justify-content: space-between;
  font-size: 12px;
  column-gap: 10px;
  border-bottom: 1px solid;
`
